import React, { useContext } from 'react';
import { MeetingContainerContextState } from './interfaces';

export const createMeetingContainerContext = () => React.createContext<MeetingContainerContextState | undefined>(undefined);

export const MeetingContainerContext = createMeetingContainerContext();

// raiseIfUndefined=false in case you know what you are doing and want to use the
// context in an optional way, for example a component that can be used both inside and outside of a meeting context
export function useMeetingContainerContext(options?: { raiseIfUndefined?: true }): MeetingContainerContextState;
export function useMeetingContainerContext(options: { raiseIfUndefined: false }): MeetingContainerContextState | undefined;
export function useMeetingContainerContext(options: { raiseIfUndefined?: boolean } = {}): MeetingContainerContextState | undefined {
    const { raiseIfUndefined = true } = options;
    const context = useContext(MeetingContainerContext);
    if (!context && raiseIfUndefined) {
        throw new Error("useMeetingCurrentContainerContext must be used within an MeetingCurrentContainerContext");
    }
    return context;
}

